module.exports = __webpack_public_path__ + "static/media/UneteEquipoMobile.5ddbc0d4.svg";